import request from '@/utils/request'

export function uploadFile(params) {
  return request({
    url: '/cmm/uploadFile',
    method: 'post',
    // headers: { 'Content-Type': 'multipart/form-data' },
    meta: { useAuth: true },
    data: params
  })
}
export function getDownloadFile(prefixDir, filePath) {
  return request({
    url: '/cmm/downloadFile/' + prefixDir + '/' + filePath,
    method: 'get'
  })
}

export function downloadFile(params) {
  return request({
    url: '/cmm/downloadFile',
    method: 'post',
    // headers: { 'Content-Type': 'Application/octet-stream' },
    meta: { useAuth: true },
    data: params
  })
}

// 총 페이지수
export function getNoticeCount(params) {
  return request({
    url: '/cmm/noticeCount',
    method: 'post',
    data: params
  })
}

export function getNoticeList(params) {
  // 차후 변경될 Restful 형식에 따라 수정해야 함
  if (!params) params = {}
  if (!params.itemsPerPage) params.itemsPerPage = 10000
  if (!params.currentPage) params.currentPage = 1

  let data = {
    startPage: (params.currentPage - 1) * params.itemsPerPage + 1,
    limitPage: params.currentPage * params.itemsPerPage
  }

  return request({
    url: '/cmm/noticeList',
    method: 'post',
    meta: { useAuth: false },
    data: data
  })
}

export function getNoticeDetail(params) {
  params = {
    row_num: params
  }
  return request({
    url: '/cmm/noticeDetail',
    method: 'post',
    data: params
  })
}

export function setNotice(params) {
  return request({
    url: '/cmm/setNotice',
    method: 'post',
    data: params
  })
}

export function deleteNotice(params) {
  return request({
    url: '/cmm/setNotice',
    method: 'delete',
    data: params
  })
}

// 명세서 총 페이지수
export function getBillCount(params) {
  return request({
    url: '/cmm/billCount',
    method: 'post',
    data: params
  })
}

export function getBillList(params) {
  // 차후 변경될 Restful 형식에 따라 수정해야 함
  if (!params) params = {}
  if (!params.itemsPerPage) params.itemsPerPage = 10
  if (!params.currentPage) params.currentPage = 1

  let data = {
    startPage: (params.currentPage - 1) * params.itemsPerPage + 1,
    limitPage: params.currentPage * params.itemsPerPage
  }

  return request({
    url: '/cmm/billList',
    method: 'post',
    data: data
  })
}

export function getBillDetailInfo(params) {
  return request({
    url: '/cmm/billDetail',
    method: 'post',
    data: params
  })
}

export function getResourceList(params) {
  return request({
    url: `/manual?${params === undefined || params.title === undefined ? '' : 'title=' + params.title}${params === undefined || params.count === undefined ? '' : '&count=' + params.count}`,
    method: 'get',
    meta: { useAuth: false }
  })
}

export function uploadResource(data) {
  return request({
    url: `/manual`,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    meta: {
      useProgress: true,
      useErrorMessage: true
    },
    method: 'post',
    data
  })
}

export function updateResource(data) {
  return request({
    url: `/manual/patch`,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    meta: {
      useProgress: true,
      useErrorMessage: true
    },
    method: 'post',
    data
  })
}

export function deleteResource(data) {
  return request({
    url: `/manual`,
    method: 'delete',
    data
  })
}

export function deleteResourceFile(data) {
  return request({
    url: `/file`,
    method: 'delete',
    data
  })
}

export function getResourceFile(seq) {
  return request({
    url: `/manual/${seq}`,
    method: 'get'
  })
}

export function downloadResourceFile(guid, seq) {
  return request({
    url: `/file/${guid}/${seq}`,
    method: 'get'
  })
}
